export default __webpack_public_path__ + "static/Laptop-72c3b53717a869433fb1ceb5ec0bc5b8.png";